import Typography from '@mui/material/Typography';

export const yesNoText = (params) => {
  if (params.value === 0) {
    return <Typography>N</Typography>;
  } else if (params.value === 1) {
    return <Typography>Y</Typography>;
  }
};
